module.exports = __webpack_public_path__ + "static/media/02.b944b1ad.jpg";